export function AgentStarIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.5 10C6.78571 8.92857 8.92857 6.78571 10 2.5C11.0714 6.78571 13.2143 8.92857 17.5 10C13.2143 11.0714 11.0714 13.2143 10 17.5C8.92857 13.2143 6.78571 11.0714 2.5 10Z" stroke="black" stroke-width="1.66667" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "AgentStarIcon";
